import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'

export const useAllowedLimits = () => {
  const { data: packagesData } = useGetPackagingLimits()
  const packagesLimits = {
    botZapping: packagesData?.botZappingDomainsLimit ? packagesData.botZappingDomainsLimit : 0,
    paidMarketing: packagesData?.paidMarketingDomainsLimit
      ? packagesData.paidMarketingDomainsLimit
      : 0,
  }

  const { data: domainsData } = useGetDomains()

  const domainsLimits = {
    botZapping: domainsData?.data.domains.filter((domain) => domain.botZapping).length ?? 0,
    paidMarketing: domainsData?.data.domains.filter((domain) => domain.paidMarketing).length ?? 0,
  }

  const domainsLeft = {
    botZapping: packagesLimits.botZapping - domainsLimits.botZapping,
    paidMarketing: packagesLimits.paidMarketing - domainsLimits.paidMarketing,
  }

  return {
    domainsLeft,
    domainsLimits,
    allowedProducts: {
      paidMarketing: (packagesData?.paidMarketingAllowed && domainsLeft.paidMarketing > 0) || false,
      botZapping: (packagesData?.botZappingAllowed && domainsLeft.botZapping > 0) || false,
    },
  }
}
